export const pos = {
  hero: {
    title: {
      pt1: 'Een gebruiksklaar',
      pt2: 'POS-device',
      pt3: 'voor online bestellingen'
    },
    description: 'Het enige apparaat dat je nodig hebt om bestellingen te verwerken. Ontvangen, beheren en printen. Alles vanuit één draagbaar apparaat.'
  },
  paragraphs: {
    paragraph_1: {
      title: 'Plug & play, serve all day',
      text: 'Geen ingewikkelde installatie of technische kennis vereist. Zet het simpelweg het apparaat gewoon aan en ga direct aan de slag. Begin binnen enkele minuten met het accepteren van je eerste bestelling.',
      cta: 'Verken de Bistroo pakketten'
    },
    paragraph_2: {
      title: 'Beheer, bevestig & print bestellingen',
      text: 'Verwerk bestellingen moeiteloos vanaf het apparaat, bevestig met één klik en geef handmatig de verwachte afhaal- of bezorgtijd door. Maak eenvoudig een terugbetaling op ieder gewenst moment. Geen extra printer nodig, alles is ingebouwd.',
      cta: ''
    },
    paragraph_3: {
      title: 'Update je shop op ieder moment',
      text: 'Sluit eenvoudig last-minute tijdsloten, zet producten tijdelijk op inactief en print snel je (dag)omzetoverzicht. Alles binnen handbereik, precies wanneer jij het nodig hebt.',
      cta: 'Verken de Bistroo pakketten'
    },
    paragraph_4: {
      title: 'Geen kabels, geen chaos',
      text: 'Volledig draadloos met een lange batterijduur, geen gedoe met kabels op jouw keukenvloer. Binnen of buiten, met WiFi en 4G kun je bestellingen op elke locatie accepteren. Je bent altijd online.',
      cta: ''
    }
  },
  key_features: {
    cards: {
      card_1: {
        title: 'Ordermanagement.',
        text: 'Beheer je orders in real-time en behoud eenvoudig overzicht over alle processen.',
        button: '',
        img_alt: ''
      },
      card_2: {
        title: 'Weet wat je verdient.',
        text: 'Bekijk je omzet voor een bepaalde periode met één simpele klik.',
        button: '',
        img_alt: ''
      },
      card_3: {
        title: 'Tijd is in jouw handen.',
        text: 'Beheer je tijdsloten moeiteloos om knelpunten in de keuken te voorkomen en je workflow te optimaliseren.',
        button: '',
        img_alt: ''
      },
      card_4: {
        title: 'Niet op voorraad, geen probleem.',
        text: 'Beheer je productvoorraad realtime met één klik.',
        button: '',
        img_alt: ''
      },
      card_5: {
        title: 'Distributie-instellingen.',
        text: 'Wijzig je distributie-instellingen in real-time en pas ze snel aan.',
        button: '',
        img_alt: ''
      }
    }
  },
  testimonial: {
    text: '"Bistroo denkt mee in oplossingen en nieuwe mogelijkheden."',
    cta: 'Lees volledig verhaal',
    name: 'Il Municipio',
    job_title: 'Italiaans Restaurant'
  }
}
